import { handleShowModal } from 'components/global/_helpers/global.helpers';
import ContextMenu from 'components/global/ContextMenu';

const FounderPiplineItemContextMenu = ({ pipelineItem }) => (
  <ContextMenu
    menuItems={[
      {
        label: 'Edit/Move',
        onClick: () => handleShowModal('founder-pipeline-edit', {
          id: pipelineItem?.id,
          name: pipelineItem?.organization?.name,
          pipelineStatus: pipelineItem?.pipelineStatus,
          amountInvested: pipelineItem?.amountInvested,
          previouslyCommitted: pipelineItem?.previouslyCommitted,
        }),
      },
      {
        label: 'Remove from Deal',
        onClick: () => handleShowModal('founder-pipeline-delete', {
          id: pipelineItem?.id,
          name: pipelineItem.organization?.name,
          dealName: pipelineItem?.deal?.name,
        }),
      },
    ]}
  />
);

export default FounderPiplineItemContextMenu;
